import { Outlet } from 'react-router-dom';

const StaticPageLayout = () => {
	return (
		<div className="h-screen">
			<div className="flex flex-1 flex-col overflow-x-hidden">
				<main>
					<Outlet />
				</main>
			</div>
		</div>
	);
};

export default StaticPageLayout;
